import React, { Component } from "react";
import { SlideDown } from "react-slidedown";
import UIfx from "uifx";
import "react-slidedown/lib/slidedown.css";
import click from "../sounds/single.mp3";
import $ from "jquery";
const clicksound = new UIfx(click, {
  volume: 0.5, // number between 0.0 ~ 1.0
  throttleMs: 100,
});
class ButtonGroup extends Component {
  // constructor(props) {
  //     super(props);

  // }
  state = {
    selectedValue: "",
    selectedDecimalValue: "",
    buttonArray: [],
    decimalButtonArray: [],
    selectedValuesArray: [],
    decimalSelectedValuesArray: [],
  };

  componentDidMount() {}

  generateButtons() {
    // alert(this.props.value)
    let arr = [0];
    let range = this.props.value;
    let i = 0;

    do {
      i = i + range / 10;
      arr.push(i);
    } while (i < range);

    this.setState({ buttonArray: arr, selectedValuesArray: [] }, this.getTotal);
    // return buttonArray;
  }

  generateDecimalButtons(type) {
    // alert(type)
    //if (type) {
    // alert(this.props.value)
    let arr = [];
    // let range = this.props.value;
    let i = 0.0 - 0.1;

    do {
      i = i + 0.1;

      arr.push((Math.round(i * 100) / 100).toFixed(1));
    } while (i < 0.8);

    this.setState({
      decimalButtonArray: arr,
      decimalSelectedValuesArray: [],
    });
    // return buttonArray;
    // } else {
    //   this.setState({ decimalButtonArray: [], decimalSelectedValuesArray: [] });
    // }
  }

  getSelectedValue = (e) => {
    if (e == 0 && this.state.selectedValuesArray.length == 0) {
      return;
    }
    // console.log(this.props.value, e);
    let arr = [0];
    let value = e;

    this.setState(
      {
        selectedValue: value,
      },
      () => this.generateSelectedValuesArray(value)
    );

    let step = 1;
    let limit = 10;

    if (value <= 100 && value.toString().length == 2) {
      step = 1;
      limit = 10;
    } else if (value <= 1000 && value.toString().length == 3) {
      step = 10;
      limit = 100;
      arr.pop("0");
      arr.push("00");
    } else if (value <= 10000 && value.toString().length == 4) {
      step = 100;
      limit = 1000;
      arr.pop("00");
      arr.push("000");
    } else if (value <= 100000 && value.toString().length == 5) {
      step = 1000;
      limit = 10000;
      arr.pop("000");
      arr.push("0000");
    } else if (value <= 1000000 && value.toString().length == 6) {
      step = 10000;
      limit = 100000;
      arr.pop("0000");
      arr.push("00000");
    } else if (value <= 10000000 && value.toString().length == 7) {
      step = 100000;
      limit = 1000000;
      arr.pop("00000");
      arr.push("000000");
    } else if (value <= 100000000 && value.toString().length == 8) {
      step = 1000000;
      limit = 10000000;
      arr.pop("000000");
      arr.push("0000000");
    } else if (value <= 1000000000 && value.toString().length == 9) {
      step = 10000000;
      limit = 100000000;
      arr.pop("0000000");
      arr.push("00000000");
    }
    // alert(step+'-------'+limit)
    let i = 0;
    do {
      i = i + step;
      arr.push(i);
    } while (i < limit - 1 * step);
    this.setState({ buttonArray: arr });
    // return buttonArray;
    clicksound.play();
    $(".btns").hide();
    $(".btns").slideDown(1500, function () {
      // Animation complete.
    });
  };

  generateDecimalSelectedValuesArray = (value) => {
    const { decimalSelectedValuesArray } = this.state;
    let newArray = [];

    // alert(value.toString().length)
    if (value < 0.01 && value.toString().length >= 5) {
     
      for (let i = 0; i < decimalSelectedValuesArray.length; i++) {
        // alert(value+'--------'+value.toString().length)
        if (decimalSelectedValuesArray[i].toString().length < 5) {
       
          newArray.push(decimalSelectedValuesArray[i]);
        }
      }
      this.setState(
        { decimalSelectedValuesArray: [...newArray, value] },
        this.getDeciTotal
      );
    } else {
    
      this.setState(
        { decimalSelectedValuesArray: [...decimalSelectedValuesArray, value] },

        this.getDeciTotal
      );
    }
  };
  getDecimalSelectedValue = (e) => {
    // if(e==0 &&  this.state.decimalSelectedValuesArray.length==0){
    //   return
    // }

    let arr = [];
    let value = e;

    this.setState(
      {
        selectedDecimalValue: value,
      },
      () => this.generateDecimalSelectedValuesArray(value)
    );

    let step = 0;
    let limit = 0;
    let round = 0;

    if (e < 0.1 && e.toString().length >= 4) {
      step = 0.001;
      limit = 0.009;
      round = 3;
    } else if (e < 1 && e.toString().length == 3) {
      step = 0.01;
      limit = 0.09;
      round = 2;
    }

    // alert(step+'-------'+limit)
    let i = 0.0;
    arr.push((0).toFixed(round));
    do {
      i = i + step;
      // console.log(i);
      arr.push(i.toFixed(round));
    } while (i < limit);
    this.setState({ decimalButtonArray: arr });
    // return buttonArray;
    clicksound.play();
    $(".dbtns").hide();
    $(".dbtns").slideDown(1500, function () {
      // Animation complete.
    });

    // console.log(this.state.decimalSelectedValuesArray)
  };

  generateSelectedValuesArray = (value) => {
    const { selectedValuesArray } = this.state;
    let newArray = [];

    if (value < 10 && value.toString().length == 1) {
      // alert('if')
      for (let i = 0; i < selectedValuesArray.length; i++) {
        // alert(value+'--------'+value.toString().length)
        if (
          selectedValuesArray[i] > 10 ||
          selectedValuesArray[i].toString().length > 1
        ) {
          newArray.push(selectedValuesArray[i]);
        }
      }
      this.setState(
        { selectedValuesArray: [...newArray, value] },
        this.getTotal
      );
    } else {
      // alert('else')
      this.setState(
        { selectedValuesArray: [...selectedValuesArray, value] },
        this.getTotal
      );
    }
    // console.log(selectedValuesArray);
  };
  getTotal = () => {
    // console.log(this.state.selectedValuesArray)
    let tot = this.state.selectedValuesArray.reduce(function (acc, val) {
      return Number(acc) + Number(val);
    }, 0);
    this.props.handler(tot);
    // $('.num').css('font-size','20px')
    // $('.num'). animate({fontSize: '75px'}, "slow");
    return tot;
  };

  getDeciTotal = () => {
    // alert('ds')
    // console.log(this.state.selectedValuesArray)
    let tot = Math.round(
      this.state.decimalSelectedValuesArray.reduce(function (acc, val) {
        return Number(acc) + Number(val);
      }, 0) * 1000
    );
    this.props.handler1(tot);
    // $('.num').css('font-size','20px')
    // $('.num'). animate({fontSize: '75px'}, "slow");
    return tot;
  };
  reSelectedValue = (num) => {
    const { selectedValuesArray } = this.state;
    this.getSelectedValue(num);
    let reSelectedValuesArray = [];
    for (let i = 0; i < selectedValuesArray.length; i++) {
      if (selectedValuesArray[i] > num) {
        reSelectedValuesArray.push(selectedValuesArray[i]);
      }
    }
    this.setState({
      selectedValuesArray: reSelectedValuesArray,
    });
  };

  reSelectedDValue = (num) => {
   
    const { decimalSelectedValuesArray } = this.state;
    this.getDecimalSelectedValue(num);
    let reSelectedValuesArray = [];
    let index=decimalSelectedValuesArray.indexOf(num)

    for (let i = 0; i < index; i++) {



      // if (decimalSelectedValuesArray[i] > num) {
        // alert("d");
        reSelectedValuesArray.push(decimalSelectedValuesArray[i]);
      // }
    }
    this.setState({
      decimalSelectedValuesArray: reSelectedValuesArray,
    });
  };

  numberWithSpaces(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  reset = () => {
    // console.log(this.state.selectedValuesArray);
    let a = this.state.selectedValuesArray;

    if (a.length >= 2) {
      this.reSelectedValue(a[a.length - 2]);
    } else {
      this.generateButtons();
      this.getTotal();
    }
  };

  resetD = () => {
    // console.log(this.state.selectedValuesArray);
    let a = this.state.decimalSelectedValuesArray;
    // alert(a.length)
    if (a.length >= 2) {
      this.reSelectedDValue(a[a.length - 2]);
    } else {
      // alert('a')
      this.generateDecimalButtons();
      this.getDeciTotal();
      this.props.handler1(0);
    }
  };
  render() {
    const {
      buttonArray,
      selectedValuesArray,
      decimalButtonArray,
      decimalSelectedValuesArray,
    } = this.state;
    const btns = buttonArray.map((number, i) => (
      <button onClick={this.getSelectedValue.bind(this, number)} key={i}>
        {this.numberWithSpaces(number)}
      </button>
    ));

    const decimalbtns = decimalButtonArray.map((number, i) => (
      <button
        onClick={this.getDecimalSelectedValue.bind(this, number)}
        key={i + "dec"}
      >
        {number}
      </button>
    ));

    const selectedbtns = selectedValuesArray.map((number, i) => (
      <button
        className="btn-selected"
        onClick={this.reSelectedValue.bind(this, number)}
        key={i}
      >
        {this.numberWithSpaces(number)}
      </button>
    ));

    const deciSelectedbtns = decimalSelectedValuesArray.map((number, i) => (
      <button
        className="btn-selected"
        onClick={this.reSelectedDValue.bind(this, number)}
        key={i}
      >
        {number}
      </button>
    ));

    let e = (
      <div>
        <h1 className="eee">e</h1>
      </div>
    );
    return (
      <div className="buttons">
        <div className="btn-group">
          {/* <SlideDown className={'my-dropdown-slidedown'}> */}
          <div className="btns" id="btns">
            {btns}

            <div>
              <i
                onClick={this.reset}
                className="fa fa-undo"
                aria-hidden="true"
              ></i>
            </div>
          </div>

          <div className="selectedbtns">{selectedbtns}</div>
        </div>
        {this.props.isdeci ? e : ""}
        <div className="btn-group">
          <div className="dbtns" id="dbtns">
            {this.props.isdeci ? decimalbtns : ""}
            {this.props.isdeci ? (
              <div>
                <i
                  onClick={this.resetD}
                  className="fa fa-undo"
                  aria-hidden="true"
                ></i>
              </div>
            ) : (
              ""
            )}
            {/* <div><i onClick={this.reset} className="fa fa-undo" aria-hidden="true"></i></div> */}
            {/* <i className="fa fa-flag-checkered" aria-hidden="true"></i> */}
          </div>
          {this.props.isdeci ? (
            <div className="selectedbtns">{deciSelectedbtns}</div>
          ) : (
            ""
          )}
        </div>
        {/* <div>{this.getTotal()}</div> */}
      </div>
    );
  }
}

export default ButtonGroup;
